enum MemberGender {
  Women = 'FEMALE',
  Men = 'MALE',
}

export default MemberGender;
